import { TOMCAT_URL } from 'src/common/index';
import _ from 'lodash';
import Divider from 'material-ui/Divider';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import CustomGoogleMap from 'src/components/maps/custom-google-map';
import busLogo from 'static/bus.png';
import CircularProgress from 'material-ui/CircularProgress';

class BusYieldLocationMap extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            companiesByLocation: this.getUniqueLocationsForCompanies(props.companies),
        };
    }
    componentWillReceiveProps(nextProps) {
        const { companies } = nextProps;

        if (!_.isEqual(companies, this.props.companiesByLocation))
            this.setState({
                companiesByLocation: this.getUniqueLocationsForCompanies(companies),
            });
    }

    componentDidMount() {
        this.waitForGoogle();
    }

    waitForGoogle() {
        if (window.google && window.google.maps) {
            this.setState({ googleReady: true });
            return;
        }
        this.pollGoogle();
    }

    pollGoogle() {
        const interval = setInterval(() => {
            if (window.google && window.google.maps) {
                clearInterval(interval);
                this.setState({ googleReady: true });
            }
        }, 100);
    }

    render() {
        if (!this.state.googleReady) return <CircularProgress />;

        return (
            <CustomGoogleMap
                containerElement={<div style={{ height: `450px` }} />}
                mapElement={<div style={{ height: `100%`, width: `100%` }} />}
                markers={
                    this.props.showCompanies
                        ? this.state.companiesByLocation.map(marker => {
                              return {
                                  position: { lat: marker.location.lat, lng: marker.location.lng },
                                  infoWindowContent: this.getInfoWindowContent(marker),
                              };
                          })
                        : []
                }
            />
        );
    }

    /**
     * renders the maps marker info window
     * with the count of buses by each company
     */
    getInfoWindowContent(marker) {
        let sumBusesTotal = 0;
        let sumBusesAvailable = 0;

        return (
            <div style={{ minWidth: '350px' }}>
                <List>
                    <Subheader>{marker.location.address}</Subheader>
                    {marker.companies.map(company => {
                        sumBusesTotal += company.totalBuses;
                        sumBusesAvailable += company.availableBuses;

                        return (
                            <ListItem
                                key={company.id}
                                disabled={true}
                                primaryText={
                                    <div>
                                        <div className="col-md-10 text-overflow">{company.companyName}</div>
                                        <div className="col-md-2">
                                            {company.availableBuses}/{company.totalBuses}
                                        </div>
                                    </div>
                                }
                                leftIcon={
                                    <img
                                        style={{ width: 'auto', height: '25px' }}
                                        src={
                                            company.logo
                                                ? `${TOMCAT_URL}public/documents/${company.logo.filename}`
                                                : busLogo
                                        }
                                        alt={`${company.companyName} Logo`}
                                    />
                                }
                                style={{
                                    paddingLeft: '70px',
                                    paddingRight: '0px',
                                    fontSize: '12px',
                                }}
                            />
                        );
                    })}
                </List>
                <br />
                <Divider />
                <List>
                    <ListItem
                        key="summary-bus-count"
                        disabled={true}
                        primaryText={<strong>{`Busse:${sumBusesAvailable}/${sumBusesTotal}`}</strong>}
                    />
                </List>
            </div>
        );
    }

    getUniqueLocationsForCompanies(companiesWithBuses) {
        const companiesByLocation = [];

        companiesWithBuses.forEach(busYieldDetails => {
            const company = busYieldDetails.company;
            const indexOfCompanyWithSameLocation = companiesByLocation.findIndex(entity =>
                _.isEqual(entity.location, company.location),
            );
            // add company to an already existing location
            if (indexOfCompanyWithSameLocation !== -1) {
                companiesByLocation[indexOfCompanyWithSameLocation].companies.push({
                    id: company.id,
                    companyName: company.companyName,
                    availableBuses: busYieldDetails.availableBuses,
                    totalBuses: busYieldDetails.totalBuses,
                    logo: company.logo,
                });
            }

            // add new location
            else {
                companiesByLocation.push({
                    location: company.location,
                    companies: [
                        {
                            id: company.id,
                            companyName: company.companyName,
                            logo: company.logo,
                            availableBuses: busYieldDetails.availableBuses,
                            totalBuses: busYieldDetails.totalBuses,
                        },
                    ],
                });
            }
        });

        return companiesByLocation;
    }
}

export default BusYieldLocationMap;
